export default function ProductLandingTemplate({ product, iframeSrc }) {
  return (
    <main>
      <section className="hero-section product-hero">
        <div className="shell">
          <p className="hero-kicker">Pénzügyi termék landing</p>
          <h1>{product.name}</h1>
          <p className="hero-lead">{product.description}</p>
          <ul className="highlight-list">
            {product.highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="calculator-section">
        <div className="shell calculator-wrap">
          <div>
            <h2>{product.name} kalkulátor</h2>
            <p>
              Töltsd ki az alapadatokat, és hasonlítsd össze az elérhető
              lehetőségeket.
            </p>
          </div>
          <div className="iframe-card">
            <iframe
              id={`bm-iframe-${product.slug}`}
              title={`${product.name} kalkulátor`}
              scrolling="no"
              width="360"
              height="590"
              src={iframeSrc}
            />
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="shell info-grid">
          <article className="info-card">
            <h3>1. Érdeklődés és igényfelmérés</h3>
            <p>
              Néhány adat megadásával pontosabb képet kapsz arról, mely
              konstrukciók lehetnek megfelelőek a céljaidhoz.
            </p>
          </article>
          <article className="info-card">
            <h3>2. Ajánlatok összehasonlítása</h3>
            <p>
              Átláthatóan láthatod a költségeket és feltételeket, így könnyebb
              kiválasztani a legjobb ajánlatot.
            </p>
          </article>
          <article className="info-card">
            <h3>3. Szakértői támogatás</h3>
            <p>
              A döntés előtt és közben is segítséget kapsz, hogy magabiztosan
              haladj végig az igénylés folyamatán.
            </p>
          </article>
        </div>
      </section>
    </main>
  );
}
